import { AddTowerPage } from './AddTowerPage';
import { activityAssociation } from './activityAssociation';
import { associateTower } from './associateTower';
import { createActivity } from './createActivity';
import { dailyActPermission } from './dailyActPermission';
import { downloadActList } from './downloadActList';
import { floorList } from './floorList';
import { getAuditNumber } from './getAuditNumber';
import { getDetailByRoomId } from './getDetailByRoomId';
import { getRole } from './getRole';
import { hasRelation } from './hasRelation';
import { permission } from './permission';
import { poolHeader } from './poolHeader';
import { queryActivities } from './queryActivities';
import { queryActivityByTowerId } from './queryActivityByTowerId';
import { queryAuditNumbers } from './queryAuditNumbers';
import { towerHeader } from './towerHeader';
import { updateActivity } from './updateActivity';
import { validTowerId } from './validTowerId';
import { validTowerList } from './validTowerList';

export default {
  AddTowerPage,
  activityAssociation,
  associateTower,
  createActivity,
  dailyActPermission,
  downloadActList,
  floorList,
  getAuditNumber,
  getDetailByRoomId,
  getRole,
  hasRelation,
  permission,
  poolHeader,
  queryActivities,
  queryActivityByTowerId,
  queryAuditNumbers,
  towerHeader,
  updateActivity,
  validTowerId,
  validTowerList,
};
